<template>
    <div id="app">
        <layout></layout>
    </div>
</template>
<script>
    import layout from './app/layout/layout'
    export default {
        name: 'app',
        components: {
           layout
        },
        mounted () {
            this.checkDomain()
        },
        methods: {
            checkDomain () {
                let url = document.location.toString()

                if (url.indexOf('.io') !== -1) {
                    this.$i18n.locale = 'en'

                    return
                }

                this.$i18n.locale = 'da'
            }
        }
    }
</script>
<style lang="scss">
    @import 'shared/styles/index';
</style>



// WEBPACK FOOTER //
// App.vue?ed9a2e18